import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a26640c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "step",
  class: "step"
}
const _hoisted_2 = {
  key: 0,
  class: "ball"
}
const _hoisted_3 = {
  key: 1,
  class: "next-step-positioner"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Step = _resolveComponent("Step", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.currentStep === _ctx.idx)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.idx + 1 < _ctx.numberOfSteps)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_Step, {
            idx: _ctx.idx + 1
          }, null, 8, ["idx"])
        ]))
      : _createCommentVNode("", true)
  ], 512))
}